import { ConcordiaNav } from '@maxpreps/apiserviceclients/apiModels';
import { publicOrigin } from '@maxpreps/network/src/origins';
import React from 'react';
import useIsAdmin from '../../hooks/useIsAdmin';
import { useIsScreenSize } from '../../hooks/useIsScreenSize';
import { COLOR } from '../../styles/colors';
import Icon, { IconType } from '../../ui/Icon/Icon';
import { iconMPLogo } from '../../ui/Icon/mp/MaxPrepsLogo';
import Anchor from '../Anchor/Anchor';
import HamburgerButton from './HamburgerButton';
import MediaDropdown from './MediaDropdown/MediaDropdown';
import MenuManager from './MenuManager';
import DesktopSearch from './Search/DesktopSearch';
import SearchButton from './Search/SearchButton';
import useSiteNavContext, { SiteNavContextProvider } from './SiteNavContext';
import { SITE_NAV_BREAK_POINT, SITE_NAV_MODE } from './SiteNavUtils';
import SportLinksList from './SportLinks/SportLinksList';
import { StyledRightNavContainer, StyledSiteNav } from './StyledSiteNav';
import UserButton from './UserButton';

const SiteNavBar: React.FC = () => {
  const { navMode } = useSiteNavContext();
  const isAdminPage = useIsAdmin();

  const isDesktop = useIsScreenSize(SITE_NAV_BREAK_POINT);
  const isSearchOpen = navMode === SITE_NAV_MODE.Search;
  const isMenuOpen =
    navMode === SITE_NAV_MODE.HamburgerMenu ||
    navMode === SITE_NAV_MODE.HamburgerMenuSearch ||
    navMode === SITE_NAV_MODE.UserMenu;

  return (
    <>
      <StyledSiteNav>
        {!isAdminPage && !isDesktop && <HamburgerButton />}

        <Anchor href={publicOrigin} $padding="0 16px 0 25px">
          <Icon
            iconType={IconType.MaxPreps}
            icon={iconMPLogo}
            color={COLOR.white}
            width={96}
          />
        </Anchor>

        {!isAdminPage && isDesktop && isSearchOpen && <DesktopSearch />}

        <SportLinksList
          isVisible={!isAdminPage && !isSearchOpen && isDesktop}
        />

        <StyledRightNavContainer>
          {!isAdminPage && isDesktop && !isSearchOpen && <MediaDropdown />}
          {!isAdminPage && <SearchButton />}
          <UserButton />
        </StyledRightNavContainer>
      </StyledSiteNav>

      {isMenuOpen && <MenuManager />}
    </>
  );
};

const SiteNav: React.FC<{ siteNavData: ConcordiaNav }> = ({ siteNavData }) => (
  <SiteNavContextProvider siteNavData={siteNavData}>
    <SiteNavBar />
  </SiteNavContextProvider>
);

export default SiteNav;
